import { render } from "./Investasi.vue?vue&type=template&id=8f0f88aa"
import script from "./Investasi.vue?vue&type=script&lang=js"
export * from "./Investasi.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__